import getAceDocsFile, { AceDownloadParams } from '@/lib/getAceDocsFile'
import JsFileDownloader from 'js-file-downloader'
import { trackUniversalResourceEvent } from './gtmTracking'

export async function downloadAceDocs(
	param: AceDownloadParams,
	abortSignal?: AbortSignal,
	pageUrl?: string,
	syllabusContext?: {
		codename?: string
		isLifeSkills?: boolean
		isMainstream?: boolean
	},
): Promise<[boolean, string]> {
	const { ok, output, message } = await getAceDocsFile(param, abortSignal)
	if (ok && output && output.code === 200) {
		// Track the download event using GTM tracking utility
		try {
			const resourcesToTrack = [
				{
					id: `ace-docs-${param.subgroup}`,
					name: output.name || 'ACE Documents',
					filename: output.name,
					contentType: output.mimeType,
					fileSize: output.size,
					url: output.path,
					resourceType: 'ace_documents',
					stages: [], // ACE docs don't have stages
					syllabuses: [], // ACE docs don't have syllabuses
					syllabus_types: [], // ACE docs don't have syllabus types
				},
			]

			trackUniversalResourceEvent(
				true,
				resourcesToTrack,
				'ACE Subgroup',
				pageUrl,
				undefined,
				syllabusContext,
			)
		} catch (error) {
			console.warn(
				'GTM tracking failed for ACE documents download:',
				error,
			)
		}

		new JsFileDownloader({
			url: output.path,
			filename: output.name,
			autoStart: true,
			forceDesktopMode: true,
		})
		return [true, '']
	}
	return [false, (output?.message || message) ?? 'No documents generated']
}
